import { formatVerbatimMoneyCurrency } from '@shared/utils/formatMoneyDisplay';
import { NOT_RECORDED_LABEL } from '../../utils/fundStatementLabels';

export function SummaryText({ loading, text }: { loading: boolean; text: string | null }) {
    if (loading) {
        return (
            <span className="text-mp-muted">
                <span aria-hidden="true">{'…'}</span>
                <span className="sr-only">Loading</span>
            </span>
        );
    }
    return <>{text ?? ''}</>;
}

export function MoneyCell({ value, currency }: { value: string | null; currency: string }) {
    return (
        <span className="block whitespace-nowrap text-right tabular-nums">
            {value === null ? (
                <>
                    <span aria-hidden="true">{'–'}</span>
                    <span className="sr-only">{NOT_RECORDED_LABEL}</span>
                </>
            ) : (
                formatVerbatimMoneyCurrency(value, currency)
            )}
        </span>
    );
}
